


































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import PriceUtils from "../../shared/PriceUtils";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import RentalBookingJson, { getRentalBookingTotalPrice } from "../../shared/RentalBookingJson";
import RentalConditionJson, { getRentalConditionPrice } from "../../shared/RentalConditionJson";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateRentalConditionJson, validateUniqueRentalConditionTitle } from "../../shared/RentalConditionJson";

export default Vue.extend({
  name: "RentalBookingConditionInput",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    rentalConditions: Array as PropType<RentalConditionJson[]>,
    data: Array as PropType<RentalConditionJson[]>,
    bookingDetails: Object as PropType<RentalBookingJson>,
    editable: Boolean,
    isAdditionalCondition: Boolean,
    customId: {
      type: Number,
      default: 0,
    },
    validation: Object,
    submitValidation: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      PriceUtils: PriceUtils,
      details: null as RentalConditionJson[] | null,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.details = [...this.data];

      this.setCachedData();
    },

    setCachedData() {},

    //START set cached data

    //END set cached data

    inputValidation(key: any, prop: any) {},

    removeValidationHint(key: any, prop: any) {},

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    getConditionTotalPrice(condition: RentalConditionJson): number | null {
      if (this.bookingDetails != null) {
        return getRentalConditionPrice(
          condition,
          this.bookingDetails.amount,
          new Date(this.bookingDetails.beginDate),
          new Date(this.bookingDetails.endDate)
        );
      }

      return null;
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    details: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.$emit("change", this.details);
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
